// @flow

import React, { type Node } from 'react';
import { Info } from './info';
import styled from 'styled-components';
import { MerchantInfo } from '../../../../organisms/merchant-info';
import { Header } from '../../../../organisms/header';

export function ArabicPage(): Node {
  return (
    <Root>
      <Header />
      <Block>
        <Info />
        <MerchantInfo />
      </Block>
    </Root>
  );
}

const Root = styled.section`
  text-align: center;
  font-family: ${props => props.theme.fontFamily.sansSerif};

  > * {
    width: 100%;
  }
`;

const Block = styled.div`
  padding: 32px;
  gap: 32px;
  display: flex;
  justify-content: space-around;
  flex-direction: column;
`;
